import { EventEmitter, Component, ElementRef, Renderer2, ChangeDetectorRef, ViewChild, Input, HostBinding, HostListener, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, state, style, transition, group, query, animateChild, animate } from '@angular/animations';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["backdrop"];
const _c1 = function (a0) { return { tooltipText: a0, automationSuffix: "-reader" }; };
function AwTooltipComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementContainer(1, 0);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c1, ctx_r1.asyncValue));
} }
function AwTooltipComponent_ng_template_4_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function AwTooltipComponent_ng_template_4_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtemplate(1, AwTooltipComponent_ng_template_4_div_1_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    const automationSuffix_r5 = ctx_r9.automationSuffix;
    const valueTest_r4 = ctx_r9.tooltipText;
    ɵngcc0.ɵɵattribute("automation", "template" + automationSuffix_r5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", valueTest_r4);
} }
function AwTooltipComponent_ng_template_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 11);
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    const valueTest_r4 = ctx_r10.tooltipText;
    const automationSuffix_r5 = ctx_r10.automationSuffix;
    ɵngcc0.ɵɵproperty("innerHTML", valueTest_r4, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵattribute("automation", "value" + automationSuffix_r5);
} }
function AwTooltipComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 6);
    ɵngcc0.ɵɵtemplate(1, AwTooltipComponent_ng_template_4_div_1_Template, 2, 2, "div", 7);
    ɵngcc0.ɵɵtemplate(2, AwTooltipComponent_ng_template_4_div_2_Template, 1, 2, "div", 8);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r3.options["contentType"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "template");
} }
const _c2 = function (a0) { return { tooltipText: a0, automationSuffix: "" }; };
const _c3 = function (a0, a1, a2, a3, a4, a5, a6, a7, a8) { return { backdropScaleXFactor: a0, backdropScaleYFactor: a1, backdropRight: a2, backdropLeft: a3, backdropTop: a4, backdropBottom: a5, backdropBorderRadius: a6, backdropTransformOrigin: a7, transitionFunc: a8 }; };
const _c4 = function (a0, a1) { return { value: a0, params: a1 }; };
const STATUS_CLOSED = 'closed';
const STATUS_OPEN = 'open';
const TRANSITION_FUNC_DEFAULT = 'cubic-bezier(.24,.88,.8,.99)';
class AwTooltipComponent {
    constructor(elementRef, renderer, cdr) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.cdr = cdr;
        this._show = false;
        this.events = new EventEmitter();
        this.animationStatus = STATUS_CLOSED;
        this.backdropScaleXFactor = 1;
        this.backdropScaleYFactor = 1;
        this.hostMargin = '0';
        this.backdropTop = 'auto';
        this.backdropLeft = 'auto';
        this.backdropRight = 'auto';
        this.backdropBottom = 'auto';
        this.backdropBorderRadius = '0';
        this.backdropTransformOrigin = '0 0';
        this.tooltipType = 'tooltip';
    }
    get arcSlideRight() {
        switch (this.actualPlacement) {
            case 'right':
                this.backdropBorderRadius = '0 14px 14px 0';
                this.backdropTransformOrigin = '5% 50%';
                this.backdropLeft = '0';
                this.backdropTop = 'calc(50% - 7px)';
                this.backdropRight = 'auto';
                this.backdropBottom = 'auto';
                return {
                    value: this.animationStatus,
                    params: {
                        hostMargin: '0 0 0 -10px',
                        transitionFunc: this.transitionFunc
                    }
                };
            case 'left':
                this.backdropBorderRadius = '14px 0 0 14px';
                this.backdropTransformOrigin = '95% 50%';
                this.backdropRight = '0';
                this.backdropTop = 'calc(50% - 7px)';
                this.backdropBottom = 'auto';
                this.backdropLeft = 'auto';
                return {
                    value: this.animationStatus,
                    params: {
                        hostMargin: '0 0 0 10px',
                        transitionFunc: this.transitionFunc
                    }
                };
            case 'top':
                this.backdropBorderRadius = '14px 14px 0 0';
                this.backdropTransformOrigin = '50% 95%';
                this.backdropBottom = '0';
                this.backdropLeft = 'calc(50% - 7px)';
                this.backdropTop = 'auto';
                this.backdropRight = 'auto';
                return {
                    value: this.animationStatus,
                    params: {
                        hostMargin: '10px 0 0 0',
                        transitionFunc: this.transitionFunc
                    }
                };
            case 'bottom':
                this.backdropBorderRadius = '0 0 14px 14px';
                this.backdropTransformOrigin = '50% 5%';
                this.backdropTop = '0';
                this.backdropLeft = 'calc(50% - 7px)';
                this.backdropBottom = 'auto';
                this.backdropRight = 'auto';
                return {
                    value: this.animationStatus,
                    params: {
                        hostMargin: '-10px 0 0 0',
                        transitionFunc: this.transitionFunc
                    }
                };
            default:
        }
        return false;
    }
    transitionEnd() {
        if (this.show) {
            this.events.emit({
                type: 'shown'
            });
        }
    }
    set show(value) {
        this.renderer.setStyle(this.elementRef.nativeElement, 'display', value ? null : 'none');
        if (value) {
            this.setPosition();
            if (this.tooltipType === 'toggletip') {
                setTimeout(() => {
                    this.asyncValue = this.value;
                    this.cdr.markForCheck();
                });
            }
        }
        else {
            this.animationStatus = STATUS_CLOSED;
            this.asyncValue = undefined;
        }
        this._show = value;
        this.hostClassShow = value;
    }
    get show() {
        return this._show;
    }
    get placement() {
        return this.data.options.placement;
    }
    get autoPlacement() {
        return this.data.options.autoPlacement;
    }
    get element() {
        return this.data.element;
    }
    get elementPosition() {
        return this.data.elementPosition;
    }
    get options() {
        return this.data.options;
    }
    get value() {
        return this.data.value;
    }
    get tooltipOffset() {
        return Number(this.data.options.offset);
    }
    get transitionFunc() {
        return `${this.options.animationDuration}ms cubic-bezier(.24,.88,.8,.99)`;
    }
    ngOnInit() {
        this.actualPlacement = this.placement;
    }
    ngAfterContentInit() {
        this.setCustomClass();
        this.setStyles();
        this.setAutomationValue();
    }
    setScaleFactors() {
        const tooltipWidth = this.elementRef.nativeElement.offsetWidth;
        const tooltipHeight = this.elementRef.nativeElement.offsetHeight;
        const backdropWidth = this.backdrop.nativeElement.clientWidth;
        const backdropHeight = this.backdrop.nativeElement.clientHeight;
        this.backdropScaleXFactor = (2 * tooltipWidth) / backdropWidth;
        this.backdropScaleYFactor = (2 * tooltipHeight) / backdropHeight;
    }
    setPosition() {
        if (this.setHostStyle(this.placement)) {
            this.setPlacementClass(this.placement);
        }
        else {
            const placements = ['top', 'right', 'bottom', 'left'];
            let isPlacementSet;
            for (const placement of placements) {
                if (this.setHostStyle(placement)) {
                    this.setPlacementClass(placement);
                    this.actualPlacement = placement;
                    isPlacementSet = true;
                    return;
                }
            }
            if (!isPlacementSet) {
                this.setHostStyle(this.placement, true);
                this.setPlacementClass(this.placement);
            }
        }
    }
    setPlacementClass(placement) {
        this.renderer.addClass(this.elementRef.nativeElement, `tooltip-${placement}`);
    }
    setHostStyle(placement, disableAutoPlacement = false) {
        const isSvg = this.element instanceof SVGElement;
        const tooltip = this.elementRef.nativeElement;
        const isCustomPosition = !this.elementPosition.right;
        let elementHeight = isSvg
            ? this.element.getBoundingClientRect().height
            : this.element.offsetHeight;
        let elementWidth = isSvg
            ? this.element.getBoundingClientRect().width
            : this.element.offsetWidth;
        const elementChildren = this.element.children;
        if (elementChildren.length) {
            elementChildren.map = [].map;
            const childHeights = elementChildren.map((child) => (child instanceof SVGElement
                ? child.getBoundingClientRect().height
                : child.offsetHeight));
            childHeights.push(elementHeight);
            elementHeight = Math.max.apply(null, childHeights);
        }
        const tooltipHeight = tooltip.clientHeight;
        const tooltipWidth = tooltip.clientWidth;
        const offsetParent = tooltip.offsetParent || document.body;
        const scrollY = offsetParent.pageYOffset || 0;
        const parentRect = offsetParent.getBoundingClientRect();
        const elementParentRect = this.element.getBoundingClientRect();
        if (isCustomPosition) {
            elementHeight = 0;
            elementWidth = 0;
        }
        let topStyle;
        let leftStyle;
        if (placement === 'top') {
            topStyle = (this.elementPosition.top - parentRect.top + scrollY) - (tooltipHeight + this.tooltipOffset);
        }
        if (placement === 'bottom') {
            topStyle = (this.elementPosition.top - parentRect.top + scrollY) + elementHeight + this.tooltipOffset;
        }
        if (placement === 'top' || placement === 'bottom') {
            leftStyle = (this.elementPosition.left - parentRect.left + elementWidth / 2) - tooltipWidth / 2;
        }
        if (placement === 'left') {
            leftStyle = this.elementPosition.left - parentRect.left - tooltipWidth - this.tooltipOffset;
        }
        if (placement === 'right') {
            leftStyle = this.elementPosition.left - parentRect.left + elementWidth + this.tooltipOffset;
        }
        if (placement === 'left' || placement === 'right') {
            topStyle = (this.elementPosition.top - parentRect.top + scrollY) + elementHeight / 2
                - tooltip.clientHeight / 2;
        }
        if (this.autoPlacement && !disableAutoPlacement) {
            const topEdge = topStyle;
            const bottomEdge = topStyle + tooltipHeight;
            const leftEdge = leftStyle;
            const rightEdge = leftStyle + tooltipWidth;
            const bodyHeight = window.innerHeight + scrollY;
            const bodyWidth = document.body.clientWidth;
            if (topEdge < 0) {
                this.actualPlacement = 'bottom';
                return false;
            }
            if (bottomEdge > bodyHeight && (elementParentRect.left - (tooltipWidth / 2) > 0)) {
                this.actualPlacement = 'top';
                return false;
            }
            if (leftEdge < 0 && (elementParentRect.left - (tooltipWidth / 2) < 0)) {
                this.actualPlacement = 'right';
                return false;
            }
            if (rightEdge > bodyWidth) {
                this.actualPlacement = 'left';
                return false;
            }
        }
        this.hostStyleTop = `${topStyle}px`;
        this.hostStyleLeft = `${leftStyle}px`;
        return true;
    }
    setZIndex() {
        if (this.options.zIndex !== 0) {
            this.hostStyleZIndex = this.options.zIndex;
        }
    }
    setPointerEvents() {
        if (this.options.pointerEvents) {
            this.hostStylePointerEvents = this.options.pointerEvents;
        }
    }
    setCustomClass() {
        if (this.options.tooltipClass) {
            this.options.tooltipClass.split(' ').forEach((className) => {
                this.renderer.addClass(this.elementRef.nativeElement, className);
            });
        }
    }
    setAnimationDuration() {
        this.hostStyleTransition = `opacity ${this.options.animationDuration}ms`;
    }
    setStyles() {
        this.setZIndex();
        this.setPointerEvents();
        this.setAnimationDuration();
        this.hostStyleMaxWidth = `${this.options.maxWidth}px`;
        this.hostStyleWidth = this.options.width ? `${this.options.width}px` : '';
        this.hostStyleOpacity = 1;
        window.setTimeout(() => {
            this.setAnimationStatusToOpen();
            this.setScaleFactors();
        }, 0);
    }
    setAutomationValue() {
        this.renderer.setAttribute(this.elementRef.nativeElement, 'automation', this.options.automationValue);
    }
    setAnimationStatusToOpen() {
        this.animationStatus = STATUS_OPEN;
    }
}
AwTooltipComponent.ɵfac = function AwTooltipComponent_Factory(t) { return new (t || AwTooltipComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
AwTooltipComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AwTooltipComponent, selectors: [["aw-tooltip"]], viewQuery: function AwTooltipComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c0, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.backdrop = _t.first);
    } }, hostAttrs: [1, "material-tooltip"], hostVars: 19, hostBindings: function AwTooltipComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("transitionend", function AwTooltipComponent_transitionend_HostBindingHandler() { return ctx.transitionEnd(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵsyntheticHostProperty("@slide", ctx.arcSlideRight);
        ɵngcc0.ɵɵstyleProp("top", ctx.hostStyleTop)("left", ctx.hostStyleLeft)("z-index", ctx.hostStyleZIndex)("pointer-events", ctx.hostStylePointerEvents)("transition", ctx.hostStyleTransition)("max-width", ctx.hostStyleMaxWidth)("width", ctx.hostStyleWidth)("opacity", ctx.hostStyleOpacity);
        ɵngcc0.ɵɵclassProp("tooltip-show", ctx.hostClassShow);
    } }, inputs: { show: "show", data: "data", elementId: "elementId" }, decls: 6, vars: 19, consts: [[3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["automation", "backdrop", 1, "backdrop"], ["backdrop", ""], ["class", "visuallyhidden", "role", "status", 4, "ngIf"], ["htmlOrStringTemplate", ""], ["role", "status", 1, "visuallyhidden"], [3, "ngSwitch"], ["role", "tooltip", 4, "ngSwitchCase"], ["role", "tooltip", "class", "inner", 3, "innerHTML", 4, "ngSwitchDefault"], ["role", "tooltip"], [4, "ngTemplateOutlet"], ["role", "tooltip", 1, "inner", 3, "innerHTML"]], template: function AwTooltipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainer(0, 0);
        ɵngcc0.ɵɵelement(1, "div", 1, 2);
        ɵngcc0.ɵɵtemplate(3, AwTooltipComponent_div_3_Template, 2, 4, "div", 3);
        ɵngcc0.ɵɵtemplate(4, AwTooltipComponent_ng_template_4_Template, 3, 2, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(5);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(4, _c2, ctx.value));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("@showBackdrop", ɵngcc0.ɵɵpureFunction2(16, _c4, ctx.animationStatus, ɵngcc0.ɵɵpureFunctionV(6, _c3, [ctx.backdropScaleXFactor, ctx.backdropScaleYFactor, ctx.backdropRight, ctx.backdropLeft, ctx.backdropTop, ctx.backdropBottom, ctx.backdropBorderRadius, ctx.backdropTransformOrigin, ctx.transitionFunc])));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tooltipType === "toggletip");
    } }, directives: [ɵngcc1.NgTemplateOutlet, ɵngcc1.NgIf, ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc1.NgSwitchDefault], styles: [".material-tooltip[_nghost-%COMP%]{background-color:rgba(0,0,0,0);border-radius:3px;border-radius:var(--tooltip-border-radius,3px);color:#232a30;color:var(--tooltip-color,#232a30);font-size:.875rem;left:0;line-height:120%;max-width:250px;min-height:36px;opacity:0;overflow:hidden;padding:1rem;padding:var(--tooltip-padding,1rem);position:absolute;text-align:center;top:0;white-space:normal;word-break:break-word;z-index:2000}@media (forced-colors:active){.material-tooltip[_nghost-%COMP%]{border:1px solid rgba(0,0,0,0)}}@media (inverted-colors){.material-tooltip[_nghost-%COMP%]{border:1px solid rgba(0,0,0,0)}}@media screen and (-ms-high-contrast:active){.material-tooltip[_nghost-%COMP%]{border:1px solid #fff;border:1px solid var(--white,#fff)}}@media screen and (-ms-high-contrast:black-on-white){.material-tooltip[_nghost-%COMP%]{border:1px solid #000;border:1px solid var(--black,#000)}}.material-tooltip[_nghost-%COMP%]   .backdrop[_ngcontent-%COMP%]{background:#fff;background:var(--tooltip-bg,#fff)}.material-tooltip.left-align[_nghost-%COMP%]{text-align:left}.material-tooltip.right-align[_nghost-%COMP%]{text-align:right}.backdrop[_ngcontent-%COMP%]{-ms-transform-origin:50% 0;background:#fff;background:var(--tooltip-background,#fff);border-radius:0 0 50% 50%;height:7px;opacity:0;position:absolute;transform:translateZ(0);transform-origin:50% 0;width:14px;z-index:-1}.tooltipped[_ngcontent-%COMP%], [tooltipped][_ngcontent-%COMP%]{cursor:pointer}"], data: { animation: [
            trigger('slide', [
                state(STATUS_OPEN, style({
                    margin: 0,
                    opacity: 1
                })),
                state(STATUS_CLOSED, style({
                    margin: '{{ hostMargin }}',
                    opacity: 0
                }), {
                    params: {
                        hostMargin: '0 0 0 -10px',
                        transitionFunc: TRANSITION_FUNC_DEFAULT
                    }
                }),
                transition(`${STATUS_OPEN} => ${STATUS_CLOSED}`, [
                    group([
                        query('@showBackdrop', animateChild()),
                        animate('{{ transitionFunc }}', style({
                            margin: '{{ hostMargin }}',
                            opacity: 0
                        }))
                    ])
                ]),
                transition(`${STATUS_CLOSED} => ${STATUS_OPEN}`, [
                    group([
                        query('@showBackdrop', animateChild()),
                        animate('{{ transitionFunc }}', style({
                            margin: 0,
                            opacity: 1
                        }))
                    ])
                ])
            ]),
            trigger('showBackdrop', [
                state(STATUS_OPEN, style({
                    opacity: 1,
                    transform: 'scale({{ backdropScaleXFactor }}, {{ backdropScaleYFactor }})',
                    transformOrigin: '{{ backdropTransformOrigin }}',
                    left: '{{ backdropLeft }}',
                    top: '{{ backdropTop }}',
                    bottom: '{{ backdropBottom }}',
                    right: '{{ backdropRight }}',
                    width: '14px',
                    height: '14px',
                    borderRadius: '{{ backdropBorderRadius }}'
                }), {
                    params: {
                        backdropScaleXFactor: 1,
                        backdropScaleYFactor: 1,
                        backdropRight: 'auto',
                        backdropLeft: '0',
                        backdropTop: '50%',
                        backdropBottom: 'auto',
                        backdropBorderRadius: '14px 0 0 14px',
                        backdropTransformOrigin: '5% 50%',
                        transitionFunc: TRANSITION_FUNC_DEFAULT
                    }
                }),
                state(STATUS_CLOSED, style({
                    opacity: 0,
                    transform: 'scale(0, 0)',
                    transformOrigin: '{{ backdropTransformOrigin }}',
                    left: '{{ backdropLeft }}',
                    top: '{{ backdropTop }}',
                    bottom: '{{ backdropBottom }}',
                    right: '{{ backdropRight }}',
                    width: '14px',
                    height: '14px',
                    borderRadius: '{{ backdropBorderRadius }}'
                }), {
                    params: {
                        backdropScaleXFactor: 1,
                        backdropScaleYFactor: 1,
                        backdropRight: 'auto',
                        backdropLeft: '0',
                        backdropTop: '50%',
                        backdropBottom: 'auto',
                        backdropBorderRadius: '14px 0 0 14px',
                        backdropTransformOrigin: '5% 50%',
                        transitionFunc: TRANSITION_FUNC_DEFAULT
                    }
                }),
                transition(`${STATUS_OPEN} => ${STATUS_CLOSED}`, [
                    animate('{{ transitionFunc }}', style({
                        transform: 'scale(0, 0)',
                        transformOrigin: '{{ backdropTransformOrigin }}',
                        opacity: 0
                    }))
                ]),
                transition(`${STATUS_CLOSED} => ${STATUS_OPEN}`, [
                    animate('{{ transitionFunc }}', style({
                        transform: 'scale({{ backdropScaleXFactor }}, {{ backdropScaleYFactor }})',
                        transformOrigin: '{{ backdropTransformOrigin }}',
                        opacity: 1
                    }))
                ])
            ])
        ] } });
AwTooltipComponent.selectorDowngrade = 'aw-tooltip';
AwTooltipComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: ChangeDetectorRef }
];
AwTooltipComponent.propDecorators = {
    backdrop: [{ type: ViewChild, args: ['backdrop', { static: true },] }],
    data: [{ type: Input }],
    elementId: [{ type: Input }],
    hostStyleTop: [{ type: HostBinding, args: ['style.top',] }],
    hostStyleLeft: [{ type: HostBinding, args: ['style.left',] }],
    hostStyleZIndex: [{ type: HostBinding, args: ['style.z-index',] }],
    hostStyleTransition: [{ type: HostBinding, args: ['style.transition',] }],
    hostStyleWidth: [{ type: HostBinding, args: ['style.width',] }],
    hostStyleMaxWidth: [{ type: HostBinding, args: ['style.max-width',] }],
    hostStyleOpacity: [{ type: HostBinding, args: ['style.opacity',] }],
    hostStylePointerEvents: [{ type: HostBinding, args: ['style.pointer-events',] }],
    hostClassShow: [{ type: HostBinding, args: ['class.tooltip-show',] }],
    arcSlideRight: [{ type: HostBinding, args: ['@slide',] }],
    transitionEnd: [{ type: HostListener, args: ['transitionend',] }],
    show: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwTooltipComponent, [{
        type: Component,
        args: [{
                selector: 'aw-tooltip',
                template: "<ng-container [ngTemplateOutlet]=\"htmlOrStringTemplate\" [ngTemplateOutletContext]=\"{tooltipText:value, automationSuffix: ''}\"></ng-container>\n<div\n    class=\"backdrop\"\n    automation=\"backdrop\"\n\n    #backdrop\n    [@showBackdrop]=\"{\n        value: animationStatus,\n        params: {\n            backdropScaleXFactor: backdropScaleXFactor,\n            backdropScaleYFactor: backdropScaleYFactor,\n            backdropRight: backdropRight,\n            backdropLeft: backdropLeft,\n            backdropTop: backdropTop,\n            backdropBottom: backdropBottom,\n            backdropBorderRadius: backdropBorderRadius,\n            backdropTransformOrigin: backdropTransformOrigin,\n            transitionFunc: transitionFunc\n        }\n    }\"\n></div>\n<div class=\"visuallyhidden\" role=\"status\" *ngIf=\"tooltipType==='toggletip'\">\n    <ng-container [ngTemplateOutlet]=\"htmlOrStringTemplate\" [ngTemplateOutletContext]=\"{tooltipText:asyncValue, automationSuffix: '-reader'}\"></ng-container>\n</div>\n\n<ng-template #htmlOrStringTemplate\n    let-valueTest=\"tooltipText\"\n    let-automationSuffix=\"automationSuffix\"\n    >\n    <ng-container [ngSwitch]=\"options['contentType']\">\n        <div\n            [attr.automation]=\"'template'+automationSuffix\"\n            *ngSwitchCase=\"'template'\"\n            role=\"tooltip\"\n        >\n            <ng-container *ngTemplateOutlet=\"valueTest\"></ng-container>\n        </div>\n\n        <div\n            *ngSwitchDefault\n            role=\"tooltip\"\n            [innerHTML]=\"valueTest\"\n            [attr.automation]=\"'value'+automationSuffix\"\n            class=\"inner\"\n        ></div>\n    </ng-container>\n</ng-template>\n\n\n",
                host: {
                    class: 'material-tooltip'
                },
                animations: [
                    trigger('slide', [
                        state(STATUS_OPEN, style({
                            margin: 0,
                            opacity: 1
                        })),
                        state(STATUS_CLOSED, style({
                            margin: '{{ hostMargin }}',
                            opacity: 0
                        }), {
                            params: {
                                hostMargin: '0 0 0 -10px',
                                transitionFunc: TRANSITION_FUNC_DEFAULT
                            }
                        }),
                        transition(`${STATUS_OPEN} => ${STATUS_CLOSED}`, [
                            group([
                                query('@showBackdrop', animateChild()),
                                animate('{{ transitionFunc }}', style({
                                    margin: '{{ hostMargin }}',
                                    opacity: 0
                                }))
                            ])
                        ]),
                        transition(`${STATUS_CLOSED} => ${STATUS_OPEN}`, [
                            group([
                                query('@showBackdrop', animateChild()),
                                animate('{{ transitionFunc }}', style({
                                    margin: 0,
                                    opacity: 1
                                }))
                            ])
                        ])
                    ]),
                    trigger('showBackdrop', [
                        state(STATUS_OPEN, style({
                            opacity: 1,
                            transform: 'scale({{ backdropScaleXFactor }}, {{ backdropScaleYFactor }})',
                            transformOrigin: '{{ backdropTransformOrigin }}',
                            left: '{{ backdropLeft }}',
                            top: '{{ backdropTop }}',
                            bottom: '{{ backdropBottom }}',
                            right: '{{ backdropRight }}',
                            width: '14px',
                            height: '14px',
                            borderRadius: '{{ backdropBorderRadius }}'
                        }), {
                            params: {
                                backdropScaleXFactor: 1,
                                backdropScaleYFactor: 1,
                                backdropRight: 'auto',
                                backdropLeft: '0',
                                backdropTop: '50%',
                                backdropBottom: 'auto',
                                backdropBorderRadius: '14px 0 0 14px',
                                backdropTransformOrigin: '5% 50%',
                                transitionFunc: TRANSITION_FUNC_DEFAULT
                            }
                        }),
                        state(STATUS_CLOSED, style({
                            opacity: 0,
                            transform: 'scale(0, 0)',
                            transformOrigin: '{{ backdropTransformOrigin }}',
                            left: '{{ backdropLeft }}',
                            top: '{{ backdropTop }}',
                            bottom: '{{ backdropBottom }}',
                            right: '{{ backdropRight }}',
                            width: '14px',
                            height: '14px',
                            borderRadius: '{{ backdropBorderRadius }}'
                        }), {
                            params: {
                                backdropScaleXFactor: 1,
                                backdropScaleYFactor: 1,
                                backdropRight: 'auto',
                                backdropLeft: '0',
                                backdropTop: '50%',
                                backdropBottom: 'auto',
                                backdropBorderRadius: '14px 0 0 14px',
                                backdropTransformOrigin: '5% 50%',
                                transitionFunc: TRANSITION_FUNC_DEFAULT
                            }
                        }),
                        transition(`${STATUS_OPEN} => ${STATUS_CLOSED}`, [
                            animate('{{ transitionFunc }}', style({
                                transform: 'scale(0, 0)',
                                transformOrigin: '{{ backdropTransformOrigin }}',
                                opacity: 0
                            }))
                        ]),
                        transition(`${STATUS_CLOSED} => ${STATUS_OPEN}`, [
                            animate('{{ transitionFunc }}', style({
                                transform: 'scale({{ backdropScaleXFactor }}, {{ backdropScaleYFactor }})',
                                transformOrigin: '{{ backdropTransformOrigin }}',
                                opacity: 1
                            }))
                        ])
                    ])
                ],
                styles: [":host.material-tooltip{background-color:rgba(0,0,0,0);border-radius:3px;border-radius:var(--tooltip-border-radius,3px);color:#232a30;color:var(--tooltip-color,#232a30);font-size:.875rem;left:0;line-height:120%;max-width:250px;min-height:36px;opacity:0;overflow:hidden;padding:1rem;padding:var(--tooltip-padding,1rem);position:absolute;text-align:center;top:0;white-space:normal;word-break:break-word;z-index:2000}@media (forced-colors:active){:host.material-tooltip{border:1px solid rgba(0,0,0,0)}}@media (inverted-colors){:host.material-tooltip{border:1px solid rgba(0,0,0,0)}}@media screen and (-ms-high-contrast:active){:host.material-tooltip{border:1px solid #fff;border:1px solid var(--white,#fff)}}@media screen and (-ms-high-contrast:black-on-white){:host.material-tooltip{border:1px solid #000;border:1px solid var(--black,#000)}}:host.material-tooltip .backdrop{background:#fff;background:var(--tooltip-bg,#fff)}:host.material-tooltip.left-align{text-align:left}:host.material-tooltip.right-align{text-align:right}.backdrop{-ms-transform-origin:50% 0;background:#fff;background:var(--tooltip-background,#fff);border-radius:0 0 50% 50%;height:7px;opacity:0;position:absolute;transform:translateZ(0);transform-origin:50% 0;width:14px;z-index:-1}.tooltipped,[tooltipped]{cursor:pointer}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }]; }, { arcSlideRight: [{
            type: HostBinding,
            args: ['@slide']
        }], transitionEnd: [{
            type: HostListener,
            args: ['transitionend']
        }], show: [{
            type: Input
        }], hostClassShow: [{
            type: HostBinding,
            args: ['class.tooltip-show']
        }], hostStyleTop: [{
            type: HostBinding,
            args: ['style.top']
        }], hostStyleLeft: [{
            type: HostBinding,
            args: ['style.left']
        }], hostStyleZIndex: [{
            type: HostBinding,
            args: ['style.z-index']
        }], hostStylePointerEvents: [{
            type: HostBinding,
            args: ['style.pointer-events']
        }], hostStyleTransition: [{
            type: HostBinding,
            args: ['style.transition']
        }], hostStyleMaxWidth: [{
            type: HostBinding,
            args: ['style.max-width']
        }], hostStyleWidth: [{
            type: HostBinding,
            args: ['style.width']
        }], hostStyleOpacity: [{
            type: HostBinding,
            args: ['style.opacity']
        }], backdrop: [{
            type: ViewChild,
            args: ['backdrop', { static: true }]
        }], data: [{
            type: Input
        }], elementId: [{
            type: Input
        }] }); })();

class AwTooltipModule {
}
AwTooltipModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AwTooltipModule });
AwTooltipModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AwTooltipModule_Factory(t) { return new (t || AwTooltipModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AwTooltipModule, { declarations: function () { return [AwTooltipComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AwTooltipComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwTooltipModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    AwTooltipComponent,
                ],
                exports: [
                    AwTooltipComponent,
                ],
                entryComponents: [
                    AwTooltipComponent
                ]
            }]
    }], null, null); })();

export { AwTooltipComponent, AwTooltipModule };

//# sourceMappingURL=aw-ads-components-aw-tooltip.js.map